<template>
  <div class="d-lg-none">
    <i
      class="fa fa-bars fa-lg toggle"
      @click="toggleSidebar"
    />
  </div>
</template>

<script>
export default {
  methods: {
    toggleSidebar () {
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle {
  align-items: center;
  border-radius: 12px;
  background-color: #ffffff;
  display: flex;
  height: 75px;
  justify-content: center;
  margin-right: 10px;
  width: 100px;
}
</style>
